export default "__VITE_ASSET__B4LuE2Hy__"